import React from "react";
import { ThemeColor } from "../../../../styles/theme";
import TextProps, { TextType } from "../interface";
import BaseText from "../BaseText";

function SubBody({
  children,
  customAs,
  color = ThemeColor.DGRAY,
  ...props
}: TextProps): React.ReactElement {
  return (
    <BaseText
      as={customAs ? customAs : "div"}
      type={TextType.SUB_BODY}
      {...props}
      color={color}
    >
      {children}
    </BaseText>
  );
}

export default SubBody;
